import { createContext, useCallback, useMemo, useState } from 'react';

export const MoteurReservationPriceDisplayContext = createContext({
  priceDisplayMode: 'partner',
  setPriceDisplayMode: () => {},
});

export function MoteurReservationPriceDisplayProvider({ children }) {
  // Default partner devise. UI falls back to TND when no TND→partner rate exists;
  // header selector lets the user switch to TND explicitly.
  const [priceDisplayMode, setPriceDisplayModeState] = useState('partner');
  const setPriceDisplayMode = useCallback((mode) => {
    setPriceDisplayModeState(mode === 'partner' ? 'partner' : 'tnd');
  }, []);
  const value = useMemo(
    () => ({ priceDisplayMode, setPriceDisplayMode }),
    [priceDisplayMode, setPriceDisplayMode]
  );
  return (
    <MoteurReservationPriceDisplayContext.Provider value={value}>
      {children}
    </MoteurReservationPriceDisplayContext.Provider>
  );
}
